/* src/app/views/template/components/modals/create-template-modal/components/template-creation-method/template-creation-method.component.scss */
/*# sourceMappingURL=template-creation-method.component.css.map */
